import * as actionTypes from '../constants/actionTypes';
import { updateObject } from '../../../../shared/utils';

const initialState = {
  prefilledFormData: null,
  prefilledFormError: null,
  prefilledFormLoading: false,

  savePdfFormResult: null,
  savePdfFormLoading: false,
  savePdfFormError: null,

  formParameters: null,
  formParametersLoading: false,
  formParametersError: null,

  policiesByIds: null,
  policiesByIdsLoading: false,
  policiesByIdsError: null,

  acordLookup: null,
  acordLookupLoading: false,
  acordLookupError: null,
};

const getPrefilledFormStart = (state, action) => {
  return updateObject(state, {
    prefilledFormError: null,
    prefilledFormLoading: true,
  });
};

const getPrefilledFormSuccess = (state, action) => {
  return updateObject(state, {
    prefilledFormData: action.data,
    prefilledFormError: null,
    prefilledFormLoading: false,
  });
};

const getPrefilledFormFail = (state, action) => {
  return updateObject(state, {
    prefilledFormData: null,
    prefilledFormError: action.error,
    prefilledFormLoading: false,
  });
};

const savePdfFormStart = (state, action) => {
  return updateObject(state, {
    savePdfFormResult: null,
    savePdfFormError: null,
    savePdfFormLoading: true,
  });
};

const savePdfFormSuccess = (state, action) => {
  return updateObject(state, {
    savePdfFormResult: action.data,
    savePdfFormError: null,
    savePdfFormLoading: false,
  });
};

const savePdfFormFail = (state, action) => {
  return updateObject(state, {
    savePdfFormResult: null,
    savePdfFormError: action.error,
    savePdfFormLoading: false,
  });
};

const getFormParametersStart = (state, action) => {
  return updateObject(state, {
    formParameters: null,
    formParametersError: null,
    formParametersLoading: true,
  });
};

const getFormParametersSuccess = (state, action) => {
  return updateObject(state, {
    formParameters: action.data,
    formParametersError: null,
    formParametersLoading: false,
  });
};

const getFormParametersFail = (state, action) => {
  return updateObject(state, {
    formParameters: null,
    formParametersError: action.error,
    formParametersLoading: false,
  });
};

const getPoliciesByIdsStart = (state, action) => {
  return updateObject(state, {
    policiesByIds: null,
    policiesByIdsError: null,
    policiesByIdsLoading: true,
  });
};

const getPoliciesByIdsSuccess = (state, action) => {
  return updateObject(state, {
    policiesByIds: action.data,
    policiesByIdsError: null,
    policiesByIdsLoading: false,
  });
};

const getPoliciesByIdsFail = (state, action) => {
  return updateObject(state, {
    policiesByIds: null,
    policiesByIdsError: action.error,
    policiesByIdsLoading: false,
  });
};

const getAcordLookupStart = (state, action) => {
  return updateObject(state, {
    acordLookupError: null,
    acordLookupLoading: true,
  });
};

const getAcordLookupSuccess = (state, action) => {
  return updateObject(state, {
    acordLookup: action.data,
    acordLookupError: null,
    acordLookupLoading: false,
  });
};

const getAcordLookupFail = (state, action) => {
  return updateObject(state, {
    acordLookup: null,
    acordLookupError: action.error,
    acordLookupLoading: false,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FORM_EDITOR_GET_PREFILLED_FORM_START:
      return getPrefilledFormStart(state, action);
    case actionTypes.FORM_EDITOR_GET_PREFILLED_FORM_SUCCESS:
      return getPrefilledFormSuccess(state, action);
    case actionTypes.FORM_EDITOR_GET_PREFILLED_FORM_FAIL:
      return getPrefilledFormFail(state, action);

    case actionTypes.FORM_EDITOR_SAVE_PDF_FORM_START:
      return savePdfFormStart(state, action);
    case actionTypes.FORM_EDITOR_SAVE_PDF_FORM_SUCCESS:
      return savePdfFormSuccess(state, action);
    case actionTypes.FORM_EDITOR_SAVE_PDF_FORM_FAIL:
      return savePdfFormFail(state, action);

    case actionTypes.FORM_EDITOR_GET_FORM_PARAMETERS_START:
      return getFormParametersStart(state, action);
    case actionTypes.FORM_EDITOR_GET_FORM_PARAMETERS_SUCCESS:
      return getFormParametersSuccess(state, action);
    case actionTypes.FORM_EDITOR_GET_FORM_PARAMETERS_FAIL:
      return getFormParametersFail(state, action);

    case actionTypes.FORM_EDITOR_GET_POLICIES_BY_IDS_START:
      return getPoliciesByIdsStart(state, action);
    case actionTypes.FORM_EDITOR_GET_POLICIES_BY_IDS_SUCCESS:
      return getPoliciesByIdsSuccess(state, action);
    case actionTypes.FORM_EDITOR_GET_POLICIES_BY_IDS_FAIL:
      return getPoliciesByIdsFail(state, action);

    case actionTypes.FORM_EDITOR_GET_ACORD_LOOKUP_START:
      return getAcordLookupStart(state, action);
    case actionTypes.FORM_EDITOR_GET_ACORD_LOOKUP_SUCCESS:
      return getAcordLookupSuccess(state, action);
    case actionTypes.FORM_EDITOR_GET_ACORD_LOOKUP_FAIL:
      return getAcordLookupFail(state, action);

    default:
      return state;
  }
};

export default reducer;
